import { TagManager } from '@navent-jobs/config'

const getContentGroup = section => (section === 'mis-postulaciones' ? 'Mis Postulaciones' : 'Estadisticas')

export const DataLayers = {
  VerEstadisticasOnClick: pathname => {
    let category, label

    if (pathname === 'postulaciones') {
      category = 'Mis Postulaciones'
      label = 'Icono estadisticas del aviso'
    } else {
      category = 'Aviso'
      label = 'CTA Ver estadisticas del aviso'
    }

    /**
     * El objetivo es conocer el uso que le dan los usuarios al boton de Busqueda por Beneficios.
     *
     * Debe dispararse cuando el usuario hace click en el boton de Busqueda por Beneficios.
     */

    TagManager.Push({
      event: 'trackEvent',
      content_group: category,
      content_type: 'Ir a estadisticas del aviso',
      eventLabel: label,
    })
  },
  CambiarEstadoOnClick: (section = '') => {
    /**
     * Se dispara cuando el usuario hace click en el boton "Actualiza tu estado"
     */

    TagManager.Push({
      event: 'select_content',
      content_group: getContentGroup(section),
      content_type: 'Listado de mis postulaciones',
      item_id: 'CTA Actualiza tu estado',
    })
  },
  CambiarEstadoPrint: (section = '') => {
    /**
     * Se dispara cuando se imprime el modal para cambiar el estado de postulacion
     */

    TagManager.Push({
      event: 'impression_modal',
      content_group: getContentGroup(section),
      modal_name: 'Modal de actualización estado postulación',
    })
  },
  CambiarEstadoModalClick: (option, section = '') => {
    /**
     * Se dispara cuando el usuario hace un cambio en el estado de su postulacion
     */

    TagManager.Push({
      event: 'click_modal',
      content_group: getContentGroup(section),
      modal_name: 'Modal de actualización estado postulación',
      item_id: option,
    })
  },
}
